import React, { createContext, useContext, useState } from "react";
import { CModal, CModalBody, CModalHeader, CButton } from "@coreui/react";

const ConfirmDialogContext = createContext();
export const useConfirmDialog = () => useContext(ConfirmDialogContext);

const primary = "#2681A9";
const primaryLight = "#E9F2F6";

const secondary = "#B19055";
const secondaryLight = "#f7f4ee";

export const ConfirmDialogProvider = ({ children }) => {
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    message: "",
    yesText: "Yes",
    noText: "No",
    onYes: null,
    onNo: null,
  });

  const confirmDialog = ({ title, message, yesText, noText, onYes, onNo }) => {
    setDialog({
      visible: true,
      title,
      message,
      yesText: yesText || "Yes",
      noText: noText || "No",
      onYes: onYes || (() => {}),
      onNo: onNo || (() => {}),
    });
  };

  const closeDialog = () =>
    setDialog((prev) => ({
      ...prev,
      visible: false,
    }));

  return (
    <ConfirmDialogContext.Provider value={{ confirmDialog }}>
      {children}

      <CModal visible={dialog.visible} onClose={closeDialog} alignment="center">
        <CModalHeader>
          <strong>{dialog.title}</strong>
        </CModalHeader>

        <CModalBody>
          <div style={{ padding: 10, fontSize: 16 }}>{dialog.message}</div>

          <div
            style={{
              marginTop: 20,
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
            }}
          >
            {dialog.noText && dialog.noText !== "-" &&
            <CButton
              style={{
                backgroundColor: secondary,
                borderColor: secondary,
                color: "white",
              }}
              onClick={() => {
                dialog.onNo();
                closeDialog();
              }}
            >
              {dialog.noText}
            </CButton>
            }

            <CButton
              style={{
                backgroundColor: primary,
                borderColor: primary,
                color: "white",
              }}
              onClick={() => {
                dialog.onYes();
                closeDialog();
              }}
            >
              {dialog.yesText}
            </CButton>
          </div>
        </CModalBody>
      </CModal>
    </ConfirmDialogContext.Provider>
  );
};
